import { reactive, ref } from 'vue'
import { useApi } from '@/functions/api'

export function useBranchCompanyList () {
  const api = useApi()
  const companies = ref<BranchCompany[]>([])
  const loading = ref(false)

  const getData = async () => {
    try {
      loading.value = true
      const response = await api.GET<ApiCollection<BranchCompany>>('admin/company')
      companies.value = response.data
    } finally {
      loading.value = false
    }
  }

  return {
    getData,
    loading,
    companies,
  }
}

export function useBranchList () {
  const api = useApi()
  const branches = ref<Branch[]>([])
  const loading = ref(false)

  const getData = async (params = {}) => {
    try {
      loading.value = true
      const response = await api.GET<ApiCollection<Branch>>('admin/branch', params)
      branches.value = response.data
    } finally {
      loading.value = false
    }
  }

  return {
    getData,
    loading,
    branches,
  }
}

const form = reactive<BranchForm>({
  name: '',
  code: '',
  color: '#000000',
  company_id: 0,
  receipt_header: '',
})

export function useBranchCreate () {
  const api = useApi()
  const submitting = ref(false)
  const errors = ref<FormError>({})

  const submitForm = async () => {
    try {
      submitting.value = true
      return await api.POST<Branch>('admin/branch', form)
    } catch (error) {
      errors.value = api.formErrors(error)
    } finally {
      submitting.value = false
    }
  }

  return {
    form,
    errors,
    submitting,
    submitForm,
  }
}

export function useBranchEdit () {
  const api = useApi()
  const submitting = ref(false)
  const errors = ref<FormError>({})

  const submitForm = async (id: number) => {
    try {
      submitting.value = true
      return await api.PUT<Branch>(`admin/branch/${id}`, form)
    } catch (error) {
      errors.value = api.formErrors(error)
    } finally {
      submitting.value = false
    }
  }

  return {
    form,
    errors,
    submitting,
    submitForm,
  }
}

export function useBranchDelete () {
  const api = useApi()
  const submitting = ref(false)
  const errors = ref<FormError>({})

  const submitDelete = async (id: number) => {
    try {
      submitting.value = true
      await api.DELETE(`admin/branch/${id}`)
      return id
    } catch (error) {
      errors.value = api.formErrors(error)
    } finally {
      submitting.value = false
    }
  }

  return {
    errors,
    submitting,
    submitDelete,
  }
}
